module.exports = __webpack_public_path__ + "media/images/heroes/eat-426541625f76eb0dba3daa0fae6cfade.png";